module.exports = __webpack_public_path__ + "img/3bg@2x.ddf77d45.png";